import { EnrichmentVisibility } from '@aibees/elephant/components/visibility-enrichment-filter-select/config';
import useEnrichmentMetadataStore from '@aibees/elephant/store/enrichment-metadata/enrichment-metadata-store';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import { CardVisibilityTabs } from '../card-visibility-tabs';
import { config } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichTableProps as Props } from './types';

const EnrichVisibilityTabs = memo(function EnrichVisibilityTabs() {
  const metadata = useEnrichmentMetadataStore((s) => s.metadata);
  const counts = useMemo(
    () =>
      metadata
        ? {
            private: metadata[EnrichmentVisibility.PRIVATE],
            internal: metadata[EnrichmentVisibility.INTERNAL],
          }
        : undefined,
    [metadata]
  );
  return <CardVisibilityTabs counts={counts} />;
});

const renderPrepend = () => <EnrichVisibilityTabs />;
const finalConfig = { ...config, renderTablePrependStable: renderPrepend };

export const EnrichTable = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('EnrichTable', className)}
      sx={SX.root}
      config={finalConfig}
    />
  );
});

EnrichTable.displayName = 'EnrichTable';
